import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  container: {
    border: "1px solid #70707043",
    borderRadius: "5px",
    padding: theme.spacing(2),
  },
}))

export default styles
